import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { arrayMove, SortableContainer } from 'react-sortable-hoc';
import { filter, map, pickBy, remove, union } from 'lodash'

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as agendaitemdetails from '../../../actions/agendaitemdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as fileupload from '../../../actions/fileupload';
import * as lookupMeetingList from '../../../actions/meetingdetails';
import * as toaster from '../../../actions/toaster';

import MUISelector from "../../muiselector";
import SelectColor from '../../selectcolor'
import TableCell from './tablecell'
import * as regData from '../../../../appConstants'
import Switch from 'material-ui/Switch';

const styles = {
    button: {
        margin: 12,
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
};

class AddAgendaItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            isFileUploaded: false,
            committee_id: Number(this.props.params.committee_id ? this.props.params.committee_id : this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            //agendaitem: { id: '', agenda: '', supermeeting: 0, headed_by: '', description: '', color: '', undercommittee: '', agenda_users: [] },
            agendaitem: { id: '', agenda: '', supermeeting: 0, headed_by: '', description: '', priority: 0, color: '', undercommittee: '', agenda_users: []},
            newfile: '',
        };
    }
    componentDidMount() {
        if (this.state.id) {
            this.state.setValue = false;
            // console.log(this.props.loginUser.data.committee_id,'this.state.id', this.state.id)
            this.props.actions.getAgendaItemDetails(this.state.id);
        }
        else {
            this.props.actions.getTeamUserList(this.props.loginUser.data.committee_id);
            //this.state.agendaitem = { id: '', agenda: '', supermeeting: 0, headed_by: '', description: '', color: '', undercommittee: '', agenda_users: [] }
            this.state.agendaitem = { id: '', agenda: '', supermeeting: 0, headed_by: '', description: '', priority: 0, color: '', undercommittee: '', agenda_users: [] };
            this.props.actions.lookupMeetingList(this.props.loginUser.data.committee_id);
        }
        this.props.actions.loadswitchercommittees();
    }
    handleChange(field, e) {
        // console.log(field, e.target.value)
        if (field == "filedescription") {
            const newfile = Object.assign({}, this.state.newfile, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'newfile': newfile }));
        }
        else {
            const agendaitem = Object.assign({}, this.state.agendaitem, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'agendaitem': agendaitem }));

           var agenda_users =[];
            if(field == "supermeeting" && this.props.meetingDetails.switchmeetingdetailsList){
                const meetingLst = this.props.meetingDetails.switchmeetingdetailsList;                
                const meetingUserLst = meetingLst.filter(function(el) { return (el.smeetingId ==  e.target.value) });
                if(meetingUserLst && meetingUserLst.length>0 &&  meetingUserLst[0].meeting_user){
                    agenda_users =  meetingUserLst[0].meeting_user;
                }              
            }
           
            if(field == "supermeeting" && agenda_users.length>0 && this.state.agendaitem  && this.state.agendaitem.agenda_users && !this.state.agendaitem.id){
                var agenda_users_lst = this.state.agendaitem.agenda_users;      
                map(agenda_users_lst, function (el) {
                    if(el && el.id){                        
                        el.status = false;
                    map(agenda_users, function (el1) {                      
                        if(el1 && el1.id )   {                   
                            if(el.id == el1.id){
                                el.status = true;
                            }                       
                        }     
                    });   
                  }   
                });               
                this.state.agendaitem.agenda_users = agenda_users_lst;               
            }else if(field == "supermeeting" && this.state.agendaitem && this.state.agendaitem.agenda_users && !this.state.agendaitem.id){
                var agenda_users_lst = this.state.agendaitem.agenda_users;       
                map(agenda_users_lst, function (el) {
                    if(el && el.id){                       
                        el.status = false;                   
                  }   
                });
                this.state.agendaitem.agenda_users = agenda_users_lst;
            }
        }
        // console.log(this.state)
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.changeTeam(e.target.value)
    }
    changeTeam(Committee_id) {
        if (!this.state.id)
            this.props.actions.getTeamUserList(Committee_id);
        this.props.actions.lookupMeetingList(Committee_id)

        this.props.loginUser.data.committee_id = Committee_id;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }
    handleFileSelected(file) {
        let filedescription = this.state.newfile.filedescription ? this.state.newfile.filedescription : ''
        let newfile = { 'filedescription': filedescription, 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        let formData = new FormData();
        formData.append('file', file.target.files[0])
        this.props.actions.fileUpload(formData)
        this.setState({ isFileUploaded: true });
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null
    }

    updateMeetingMinutesFileUploadStatus(file) {
        let filedescription = this.state.newfile.filedescription ? this.state.newfile.filedescription : ''
        let newfile = { 'filedescription': filedescription, 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        let formData = new FormData();
        formData.append('file', file.target.files[0])
        this.props.actions.fileUpload(formData)
        this.setState({ isFileUploaded: true });
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null
    }

    getUpdateFileDetails = (data) => {
        // console.log('getUpdateFileDetails', data)
        // Find item index using _.findIndex
        var index = _.findIndex(this.state.agendaitem.fileres, { fileId: data.fileId });
        // Replace item at index using native splice
        this.state.agendaitem.fileres.splice(index, 1, data);
        this.setState({ 'setValue': true });
    }
    getDeleteFileDetails = (data) => {
        if (data && data.fileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.agendaitem.fileres, { fileId: data.fileId });
            // Replace item at index using native splice
            this.state.agendaitem.fileres.splice(index, 1);
        }
        else if (data && data.tempFileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.agendaitem.fileres, { tempFileId: data.tempFileId });
            // Replace item at index using native splice
            this.state.agendaitem.fileres.splice(index, 1);
        }
        this.setState({ 'setValue': true });
    }
    handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.agendaitem)
        this.state.agendaitem.undercommittee = this.state.committee_id;
        if (!this.state.agendaitem.supermeeting || this.state.agendaitem.supermeeting == 0)
            this.props.actions.errorToasters("Please select a Meeting");
        else {
            if (this.state.agendaitem.id) {
                // console.log(this.state.document)
                this.props.actions.updateAgendaItemDetails(this.state.agendaitem);
            }
            else {
                this.props.actions.addAgendaItemDetails(this.state.agendaitem);
            }
        }
    }
    onSortEnd = ({ oldIndex, newIndex, collection }) => {
        if (oldIndex != newIndex) {
            // console.log(oldIndex, newIndex, collection)
            let file_id = this.state.agendaitem.fileres[oldIndex].fileId
            let old_orderLevel = this.state.agendaitem.fileres[oldIndex].orderLevel
            let meeting_id = this.state.agendaitem.id

            const agendaitem = Object.assign({}, this.state.agendaitem, { 'fileres': arrayMove(this.state.agendaitem.fileres, oldIndex, newIndex) });
            this.setState({ agendaitem: agendaitem, });
            this.props.actions.updateFileOrder(file_id, newIndex + 1, old_orderLevel, meeting_id);
        }
    };
    render() {
        const { match, loginUser, agendaitemDetails, params, teamDetails, meetingDetails, fileupload } = this.props;
        // console.log('agendaitemDetails', this.state.agendaitem)
        // console.log('agendaitemDetails.agendaitemdetails', agendaitemDetails.agendaitemdetails)
        let result = null;
        if ((fileupload && fileupload.Status) || (agendaitemDetails && agendaitemDetails.Status)
            || (teamDetails && teamDetails.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (agendaitemDetails && agendaitemDetails.agendaitemdetails && !this.state.setValue) {
            this.state.agendaitem = agendaitemDetails.agendaitemdetails;
            this.changeTeam(this.state.agendaitem.undercommittee)
            this.setState({ committee_id: Number(this.state.agendaitem.undercommittee) })
            this.state.setValue = true;
            let committee_users = this.state.agendaitem.committee_users;
            let agenda_users = this.state.agendaitem.agenda_users;
            map(agenda_users, function (el) {
                remove(committee_users, { 'id': el.id })
            });
            this.state.agendaitem.agenda_users = union(agenda_users, committee_users);
            // console.log('fileuser',this.state.agendaitem.agenda_users);
        }
        else if (teamDetails && teamDetails.teamuserList && teamDetails.apiGetResult && !this.state.id)
            this.state.agendaitem.agenda_users = teamDetails.teamuserList;

        if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
            //console.log('After upload success',fileupload.filedetails)
            fileupload.filedetails.description = this.state.newfile.filedescription;
            if (!this.state.agendaitem.fileres)
                this.state.agendaitem.fileres = [];
            this.state.agendaitem.fileres.push(fileupload.filedetails);
            this.setState({ isFileUploaded: false, newfile: '' });
           // console.log('After upload success',this.state.agendaitem.fileres)
        }

        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        let _meetingList = null
        const meetingList = meetingDetails.switchmeetingdetailsList;
        if (meetingList && meetingList.length > 0) {
            _meetingList = meetingList.map(_mdata => (
                <MenuItem key={_mdata.smeetingId} value={_mdata.smeetingId}
                    style={{ fontWeight: '500' }}>
                    {_mdata.meetingName}
                </MenuItem>
            ))
        }

        // let _fileList = null
        // const fileList = this.state.agendaitem.fileres;
        // if (fileList && fileList.length > 0) {
        //     _fileList = fileList.map((_data, index) => {
        //         return (<TableCell key={index} data={_data} index={index} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
        //             id={this.state.agendaitem.id} committee_id={this.state.committee_id} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />);
        //     })
        // }

        const FileSortableList = SortableContainer(({ fileList }) => {
            if (!fileList || fileList == false)
                return (<tbody></tbody>)
            return (
                <tbody>
                    {fileList.map((file, index) => {
                        // console.log('tbl', index)
                        // <SortableUser key={index} index={index} user={user} />
                        return <TableCell key={index} data={file} i={index} index={index} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
                            id={this.state.agendaitem.id} committee_id={this.state.committee_id} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />
                    })}
                </tbody>
            );
        });

        let _headedByList = null
        const headedByList = this.state.agendaitem.agenda_users;
        if (headedByList && headedByList.length > 0) {
            _headedByList = headedByList.map(_mdata => (
                <MenuItem key={_mdata.userId} value={_mdata.userId}
                    style={{ fontWeight: '500' }}>
                    {_mdata.userId}
                </MenuItem>
            ))
        }

        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Agenda Item" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12 ">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-white p-0">
                                    <div className="row p-2">
                                        <div className="col-6 pt-2 pl-4"> Agenda Item Details</div>
                                        <div className="col-2 text-right pt-2"> Team Name :</div>
                                        <div className="col-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                {/* <InputLabel htmlFor="age-simple">Team Switcher</InputLabel> */}
                                                <Select
                                                    value={this.state.committee_id}
                                                    onChange={this.handleChangeTeam.bind(this)}
                                                    input={<Input id="age-simple" />}
                                                    disabled={this.state.id ? true : false}
                                                >
                                                    {_TeamList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-4">
                                            <FormControl className="w-100 mb-2 col-12 pb-4">
                                                <InputLabel htmlFor="age-simple">Meeting Name</InputLabel>
                                                <Select value={Number(this.state.agendaitem.supermeeting)}
                                                    onChange={this.handleChange.bind(this, 'supermeeting')}
                                                    input={<Input id="age-simple" />} >
                                                    {_meetingList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-4 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="agenda" label="Agenda Item Name"
                                                validators={['required', regData.regexAlphaNumericLength, regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required', 'Only Alpha Numeric values are allowed', regData.messageLength]}
                                                value={this.state.agendaitem.agenda} onChange={this.handleChange.bind(this, 'agenda')} />
                                        </div>
                                        <div className="col-4 pb-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                <InputLabel htmlFor="age-simple">Headed By</InputLabel>
                                                <Select value={this.state.agendaitem.headed_by}
                                                    onChange={this.handleChange.bind(this, 'headed_by')}
                                                    input={<Input id="age-simple" />} >
                                                    {_headedByList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-2 pb-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                <InputLabel htmlFor="age-simple">Color Code</InputLabel>
                                                <SelectColor value={this.state.agendaitem.color} handleChange={this.handleChange.bind(this, 'color')} />
                                            </FormControl>
                                        </div>
                                        <div className="col-2 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                name="priority" label="Priority"
                                                validators={[regData.regexExpNum]}
                                                errorMessages={[regData.messageNumeric]}
                                                value={this.state.agendaitem.priority==''?'':parseInt(this.state.agendaitem.priority)||''} onChange={this.handleChange.bind(this, 'priority')} />
                                        </div>
                                        <div className="col-8 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                name="description" label="Description" multiline={true}
                                                validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                value={this.state.agendaitem.description} onChange={this.handleChange.bind(this, 'description')} />
                                        </div>
                                        <div className="col-12 pb-4">
                                            <MUISelector userList={this.state.agendaitem.agenda_users} />
                                        </div>
                                    </div>
                                    <Card className="">
                                        <CardBody>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h3 className="card-title">File Details</h3>
                                                </div>
                                                <div className="col-md-8">
                                                    <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                        name="filedescription" label="File Description" multiline={true}
                                                        validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                        errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                        value={this.state.newfile ? this.state.newfile.filedescription : ''} onChange={this.handleChange.bind(this, 'filedescription')} />
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-group mb-3">
                                                    </div>
                                                    <input type="file" accept="application/pdf" id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                                    <label htmlFor="fileUpload">
                                                        <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Choose file</Button>
                                                        <p class="pt-2">(Maximum size of the file should not exceed 100MB)</p>
                                                    </label>
                                                    <label className="m-2">{this.state.newfile && this.state.newfile.file ? this.state.newfile.file.name : ""}</label>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="table-responsive-material">
                                                        <table className="default-table table-unbordered table table-lg table-hover">
                                                            <thead className="th-border-b">
                                                                <tr>
                                                                    <th>Sort</th>
                                                                    <th>S.No.</th>
                                                                    <th>File Name</th>
                                                                    <th>Description</th>
                                                                    <th className="status-cell text-right">Actions</th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            {/* <tbody> */}
                                                            {/* {_fileList} */}
                                                            <FileSortableList fileList={this.state.agendaitem.fileres}
                                                                onSortEnd={this.onSortEnd} useDragHandle={true} />
                                                            {/* </tbody> */}
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/agenda/agenda-item-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div >
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, meetingDetails, agendaitemDetails, fileupload } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, meetingDetails, agendaitemDetails, params: ownProps.match.params, fileupload }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, lookupMeetingList, agendaitemdetails, fileupload, toaster), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddAgendaItem));



// WEBPACK FOOTER //
// ./app/agendaitemdetails/addagendaitem/index.js